<template>
  <div
    class="rfp-rr-most-helpful-critical-032-or rr-most-fav-review-right float-left"
    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
  >
    <div class="rfp-rr-most-helpful-critical-033-or rr-most-fav-review-right-inner">
      <h3 class="rfp-rr-most-helpful-critical-034-or rr-sub-title black">{{ headerTitle }}</h3>
      <span v-if="noFavorableReviewFound" class="rfp-rr-most-helpful-critical-035-or">
        <span
          class="rfp-rr-most-helpful-critical-036-or review-stars"
          :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
        >
          <refapp-star-rating
            :aria-label="starRatingAccessibleLabel"
            class="vue-star-rating"
            star-classes="vue-star-rating-star"
            :increment="starRatingIncrementValue"
            :max-rating="starRatingMaxRatingValue"
            :inactive-color="starRatingInactiveColor"
            :active-color="starRatingActiveColor"
            :star-size="starRatingStarSize"
            :rating="overallRating"
            readonly
          />
        </span>
        <p class="rfp-rr-most-helpful-critical-038-or clear">
          <span v-if="showHideNickname" class="rfp-rr-most-helpful-critical-039-or black bold">{{
            labelDate
          }}</span
          ><span v-if="showCreatedAt"> - {{ reviewDate }}</span>
        </p>
        <h3
          v-if="showHideSubTitle && subTitle"
          class="rfp-rr-most-helpful-critical-040-or rr-sub-title black clear"
        >
          {{ subTitle }}
        </h3>
        <p class="rfp-rr-most-helpful-critical-041-or clear">
          <span class="rfp-rr-most-helpful-critical-042-or rr-sub-content-restricted"
            >{{ subContent }}
          </span>
          <span
            role="button"
            tabindex="0"
            aria-haspopup="dialog"
            class="rfp-rr-most-helpful-critical-043-or bold rr-show-full-review"
            @keydown.space.prevent
            @keyup.space="showFullReviewPopup"
            @keydown.enter="showFullReviewPopup"
            @click="showFullReviewPopup"
          >
            {{ showFullReview }}
          </span>
        </p>
        <p
          v-if="isProductFree && showFreeProduct"
          class="rfp-rr-most-helpful-favorable-review-152-or"
        >
          <span>{{ isProductFreeDisplayText }}</span>
        </p>
        <p class="rfp-rr-most-helpful-critical-044-or clear">{{ labelHelpful }}</p>
        <p
          role="button"
          tabindex="0"
          class="rfp-rr-most-helpful-critical-045-or clear bold rr-see-more-reviews reviews-four-five"
          @keydown.space.prevent
          @keyup.space="filterRatingSpecific"
          @keyup.enter="filterRatingSpecific"
          @click="filterRatingSpecific"
        >
          {{ filterStarReviews }}
        </p>
        <p
          v-if="commentAdded"
          role="button"
          :aria-expanded="String(showCommentText)"
          tabindex="0"
          class="rfp-rr-most-helpful-critical-046-or clear bold rr-see-more-reviews reviews-four-five"
          @keydown.space.prevent
          @keyup.space="showComments"
          @keydown.enter="showComments"
          @click="showComments"
        >
          {{ commentAddedButton }}
        </p>
        <p v-if="showCommentText" class="rfp-rr-most-helpful-critical-047-or comment___text">
          {{ commentAdded }}
        </p>
      </span>
      <span v-if="!noFavorableReviewFound" class="rfp-rr-most-helpful-critical-048-or">{{
        noFavorableReviewFoundText
      }}</span>
    </div>
    <div
      v-if="activePopup"
      class="rfp-rr-most-helpful-critical-049 review-popup-overlay"
      style="display: block"
    ></div>
    <rfp-ratings-show-full-review
      v-if="activePopup"
      :header-title="headerTitlePopup"
      :label-quality-of-product="labelQualityOfProduct"
      :rate-quality-of-product="rateQualityOfProduct"
      :summary="summary"
      :rrid="rrid"
      :helpful-labels="helpfulLabel"
      :is-reported-by-user="isReportedByUser"
      :reported-text="reportedText"
      :report-text="reportText"
      :update-helpful-review-apis="updateHelpfulReviewApi"
      :update-not-helpful-review-apis="updateNotHelpfulReviewApi"
      :report-review-apis="reportReviewApi"
      :is-recommends="isRecommend"
      :helpful-icon="helpfulIcon"
      :helpful-icon-alt="helpfulIconAlt"
      :non-helpful-icon="nonHelpfulIcon"
      :non-helpful-icon-alt="nonHelpfulIconAlt"
      :recommend-list-icons="recommendListIcon"
      :recommend-icon-alt-texts="recommendIconAltText"
      :product-names="productName"
      :review-contents="subContent"
      :review-titles="subTitle"
      :facebook-captions="facebookCaption"
      :facebook-share-enableds="facebookShareEnabled"
      :share-display-configs="shareDisplayConfig"
      :facebook-icons="facebookIcon"
      :facebook-icon-alts="facebookIconAlt"
      :facebook-tool-tips="facebookToolTip"
      :show-hide-quality-of-products="showHideQualityOfProduct"
      :show-hide-sub-titles="showHideSubTitle"
      :field="fields"
      :modal-close-button-accessible-label="modalCloseButtonAccessibleLabel"
      :is-voted-by-user="localIsVotedByUser"
    >
    </rfp-ratings-show-full-review>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import RfpRatingsShowFullReview from '../rfp-ratings-show-full-review/rfp-ratings-show-full-review.vue';
import RefappStarRating from '../../../../../shared/components/star-rating/refapp-star-rating.vue';

export default {
  name: 'rfp-ratings-most-helpful-critical-review',
  components: {
    RfpRatingsShowFullReview,
    RefappStarRating,
  },
  provide() {
    const counts = {};
    Object.defineProperty(counts, 'helpfulCount', {
      enumerable: true,
      get: () => this.localHelpfulCount,
    });
    Object.defineProperty(counts, 'notHelpfulCount', {
      enumerable: true,
      get: () => this.localNotHelpfulCount,
    });

    return {
      counts,
      starRatingActiveColor: this.fields.starRatingActiveColor || this.starRatingActiveColor,
      starRatingInactiveColor: this.fields.starRatingInactiveColor || this.starRatingInactiveColor,
      starRatingIncrementValue: this.starRatingIncrementValue,
      starRatingMaxRatingValue: this.starRatingMaxRatingValue,
      starRatingStarSize: this.fields.starSize || this.starRatingStarSize,
      isRightToLeftActive: this.isRightToLeftActive,
      starRatingAccessibleLabel: this.starRatingAccessibleLabel,
      voteHelpfulAccessibleLabel: this.voteHelpfulAccessibleLabel,
      voteNotHelpfulAccessibleLabel: this.voteNotHelpfulAccessibleLabel,
    };
  },
  props: {
    headerTitle: {
      type: String,
      required: true,
    },
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    labelDate: {
      type: String,
      required: false,
    },
    reviewDate: {
      type: String,
      required: false,
    },
    subTitle: {
      type: String,
      required: false,
    },
    subContent: {
      type: String,
      required: false,
    },
    showFullReview: {
      type: String,
      required: true,
    },
    labelHelpful: {
      type: String,
      required: false,
    },
    filterStarReviews: {
      type: String,
      required: true,
    },
    noFavorableReviewFound: {
      type: Boolean,
      required: true,
    },
    noFavorableReviewFoundText: {
      type: String,
      required: true,
    },
    headerTitlePopup: {
      type: String,
      required: false,
    },
    labelQualityOfProduct: {
      type: String,
      required: true,
    },
    rateQualityOfProduct: {
      type: String,
      required: true,
    },
    summary: {
      type: String,
      required: false,
    },
    rrid: {
      type: Number,
      required: true,
    },
    helpfulLabel: {
      type: String,
      required: true,
    },
    report: {
      type: String,
      required: true,
    },
    reportedText: {
      type: String,
      required: true,
    },
    reportText: {
      type: String,
      required: true,
    },
    isVotedByUser: {
      type: Boolean,
      required: true,
    },
    helpfulCount: {
      type: Number,
      required: false,
    },
    notHelpfulCount: {
      type: Number,
      required: false,
    },
    updateHelpfulReviewApi: {
      type: String,
      required: true,
    },
    updateNotHelpfulReviewApi: {
      type: String,
      required: true,
    },
    reportReviewApi: {
      type: String,
      required: true,
    },
    isRecommend: {
      type: String,
      required: false,
    },
    commentAddedButton: {
      type: String,
      required: true,
    },
    commentAdded: {
      type: String,
      required: true,
    },
    helpfulIcon: {
      type: String,
      required: true,
    },
    helpfulIconAlt: {
      type: String,
      required: true,
    },
    nonHelpfulIcon: {
      type: String,
      required: true,
    },
    nonHelpfulIconAlt: {
      type: String,
      required: true,
    },
    recommendListIcon: {
      type: String,
      required: true,
    },
    recommendIconAltText: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    facebookCaption: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnabled: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfig: {
      type: String,
      required: true,
    },
    facebookIcon: {
      type: String,
      default: '',
    },
    facebookIconAlt: {
      type: String,
      default: '',
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
    showHideNickname: {
      type: Boolean,
      required: true,
    },
    showCreatedAt: {
      type: Boolean,
      default: true,
    },
    showHideSubTitle: {
      type: Boolean,
      required: true,
    },
    showHideQualityOfProduct: {
      type: Boolean,
      required: true,
    },
    isProductFree: {
      type: Boolean,
      required: false,
    },
    isProductFreeDisplayText: {
      type: String,
      required: '',
    },
    showFreeProduct: {
      type: Boolean,
      required: false,
    },
    fields: {
      type: Object,
      required: true,
    },
    starRatingAccessibleLabel: {
      type: String,
      default: undefined,
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: 'Close',
    },
    voteHelpfulAccessibleLabel: {
      type: String,
      default: 'Vote Helpful. {{voteCount}} people found this review helpful',
    },
    voteNotHelpfulAccessibleLabel: {
      type: String,
      default: 'Vote Not helpful. {{voteCount}} people found this review not helpful',
    },
  },
  data() {
    return {
      overallRating: this.rating,
      activePopup: false,
      showCommentText: false,
      localHelpfulCount: this.helpfulCount,
      localNotHelpfulCount: this.notHelpfulCount,
      localIsVotedByUser: this.isVotedByUser,
      isReportedByUser: this.report === this.reportedText,
    };
  },
  created() {
    if (this.$cookies.get(`reportedCookie${this.rrid}`)) {
      this.isReportedByUser = true;
    }

    if (this.$cookies.get(`helpfulCountCookie${this.rrid}`)) {
      this.localIsVotedByUser = true;
    }

    eventBus.on('rfpSetReportedStatus', ({ reviewId, isReported }) => {
      if (reviewId === this.rrid) {
        this.isReportedByUser = isReported;
      }
    });

    eventBus.on(
      'rfpUpdateReviewVote',
      ({
        reviewId,
        isHelpful,
        /** to rollback optimistic update */
        rollbackUpdate = false,
      }) => {
        if (reviewId !== this.rrid) return;

        const updateVoteKey = isHelpful ? 'localHelpfulCount' : 'localNotHelpfulCount';
        if (rollbackUpdate) {
          this[updateVoteKey]--;
          this.localIsVotedByUser = false;
        } else {
          this[updateVoteKey]++;
          this.localIsVotedByUser = true;
        }
      },
    );
  },
  methods: {
    showFullReviewPopup() {
      this.activePopup = true;
    },
    showComments() {
      if (this.showCommentText === true) {
        this.showCommentText = false;
      } else {
        this.showCommentText = true;
      }
      // this.showCommentText = this.showCommentText ? false : true;
    },
    closeFullReviewPopup() {
      this.activePopup = false;
    },
    filterRatingSpecific() {
      eventBus.emit('oneTwoThree');
      setTimeout(() => {
        this.$scrollTo('#rare-list-page');
        document
          .querySelector('#rfp-rr-ratings-reviews-results-list')
          ?.focus({ preventScroll: true });
      });
    },
  },
};
</script>
